import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/cognitive-settings'

interface Endpoints {
  getHosts: NoParamEndpointConstructor
  getEndpoints: NoParamEndpointConstructor
}

export const cognitiveSettingsEndpoints: Endpoints = {
  getHosts: () => `${baseUrl}/hosts`,
  getEndpoints: () => `${baseUrl}/endpoints`,
}
